const productionApiOrigin = "https://api.diffex.ai";
const stagingApiOrigin = "https://api.staging.diffex.ai";
const localApiOrigin = "http://api.diffex.test:4175";
const productionMarketingOrigin = "https://diffex.ai";
const localMarketingOrigin = "http://diffex.test:4173";

function runtimeApiOrigin(): string {
  const configured = import.meta.env.VITE_API_ORIGIN;

  if (configured) {
    return new URL(configured).origin;
  }

  if (window.location.hostname === "app.diffex.test") {
    return localApiOrigin;
  }

  return window.location.hostname === "app.staging.diffex.ai" ? stagingApiOrigin : productionApiOrigin;
}

function runtimeMarketingOrigin(): string {
  const configured = import.meta.env.VITE_MARKETING_ORIGIN;

  if (configured) {
    return new URL(configured).origin;
  }

  return window.location.hostname === "app.diffex.test"
    ? localMarketingOrigin
    : productionMarketingOrigin;
}

export const productConfig = {
  apiOrigin: runtimeApiOrigin(),
  marketingOrigin: runtimeMarketingOrigin(),
};

export function canonicalLocalProductUrl(value: string): string | null {
  try {
    const url = new URL(value);
    const isNumericLoopback = url.hostname === "127.0.0.1" || url.hostname === "[::1]";

    if (!isNumericLoopback) {
      return null;
    }

    url.hostname = "localhost";
    return url.toString();
  } catch {
    return null;
  }
}

export function safeReturnTo(value: string | null): string {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return "/";
  }

  try {
    const parsed = new URL(value, window.location.origin);

    return parsed.origin === window.location.origin
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : "/";
  } catch {
    return "/";
  }
}

export function loginUrl(returnTo: string): string {
  const url = new URL("/auth/login", productConfig.apiOrigin);
  url.searchParams.set("return_to", safeReturnTo(returnTo));
  return url.toString();
}
